import { useTranslation } from 'next-i18next';
import type { FC } from 'react';

import StatusMessageBox from 'components/StatusMessageBox';

const AddRfidGroupSuccess: FC = () => {
  const { t } = useTranslation();

  return (
    <StatusMessageBox
      type="success"
      message={t(
        'common:pages.rfid_groups.add_rfid_group.group_added_successfully',
      )}
    />
  );
};

export default AddRfidGroupSuccess;
